export default (name: string) => {
	return `${name} is required`;
};
